class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderMenuIconAccessibility();
    this.isOpened = false;
    window.openedDrawers = window.openedDrawers || new Set();
  }

  setHeaderMenuIconAccessibility() {
    const pickerLinks = [document.querySelector('#wild-mobile-menu-toggle')];
    for (const pickerLink of pickerLinks) {
      if (!pickerLink) continue
      pickerLink.setAttribute('role', 'button');
      pickerLink.setAttribute('aria-haspopup', 'dialog');
      pickerLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle(pickerLink)
      });
      pickerLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.toggle(pickerLink);
        }
      });
    }
  }

  toggle(triggeredBy) {
    this.setActiveElement(triggeredBy);
    if (!this.isOpened) this.open();
    else this.close();
  }

  open() {
    this.activeElement.classList.toggle('active');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('MobileMenuDrawer');
      const focusElement = this.querySelector('.drawer__inner');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    window.openedDrawers.add('mobile-menu');
    this.isOpened = true
  }

  close() {
    window.openedDrawers.delete('mobile-menu');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.activeElement && this.activeElement.classList.toggle('active');
    window.openedDrawers.size === 0 && document.body.classList.remove('overflow-hidden');
    this.isOpened = false;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);
